import Axios from "axios"
import store from '../store'

const space2CheckReport = {
  getClientId() {
    return store.getters['Client/clientId']
  },
  getSpaceOccupancyTreeView(payload) {
    return Axios.get(`/api/v1/clients/${this.getClientId()}/dashboards/space-occupancies/tree?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getGeneralOccupancy(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/dashboards/space-occupancies/occupancies?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getBusiestDateOccupancy(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/dashboards/space-occupancies/busiest-date?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getBusiestTimeOccupancy(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/dashboards/space-occupancies/busiest-time?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getWastageOccupancy(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/dashboards/space-occupancies/wastage?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getPositionsOccupancy(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/dashboards/space-occupancies/positions?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getSpaceOccupancyReportFile(payload) {
    let headers = { responseType: 'arraybuffer', ignoreGlobalCatch: true }
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/dashboards/space-occupancies/files?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`, headers)
  },
  getRoomsRankingOccupancy(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/rooms/dashboards/space-occupancies?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getRoomsPositionsOccupancy(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/rooms/dashboards/space-occupancies/positions?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getGeneralRoomOccupancy(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/rooms/dashboards/space-occupancies/occupancies?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getBusiestDateRoomOccupancy(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/rooms/dashboards/space-occupancies/busiest-date?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getBusiestTimeRoomOccupancy(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/rooms/dashboards/space-occupancies/busiest-time?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getRoomsOccupancyPerDay(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/rooms/dashboards/space-occupancies/days-of-week?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getRoomsOccupancyPerHour(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/rooms/dashboards/space-occupancies/hours?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  },
  getRoomsWastageOccupancy(payload) {
    return Axios.get(`api/v1/clients/${this.getClientId()}/locations/${payload.locationId}/rooms/dashboards/space-occupancies/wastage?start=${payload.startDate}&end=${payload.endDate}&startPeriod=${payload.startTime}&endPeriod=${payload.endTime}`)
  }
}

export default space2CheckReport
